/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
/* import specific icons */
import {
    faHome,
    faUser,
    faUserPlus,
    faUserShield,
    faSignInAlt,
    faSignOutAlt,
    faAngleDoubleLeft,
    faArrowLeft,
    faArrowUpRightFromSquare,
    faChevronDown,
    faChevronRight,
    faBarcode,
    faBuilding,
    faCalendarPlus,
    faCalendarWeek,
    faEdit,
    faTrash,
    faPrint,
    faIcons,
    faPlus,
    faSpinner,
    faSearch,
    faCircleArrowRight,
    faArrowAltCircleRight,
    faCaretUp,
    faCaretDown,
    faTriangleExclamation,
    faCircleCheck,
    faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(faHome, faUser, faUserPlus, faUserShield, faSignInAlt, faSignOutAlt, faAngleDoubleLeft,
            faArrowLeft, faArrowUpRightFromSquare, faChevronDown, faChevronRight,
            faBarcode, faBuilding, faCalendarPlus, faCalendarWeek,
            faEdit, faTrash, faPrint, faIcons, faPlus, faSpinner, faSearch,
            faCircleArrowRight, faArrowAltCircleRight, faTriangleExclamation,
            faCircleCheck, faCircleXmark
            );

export { FontAwesomeIcon };
